import videojs from 'video.js';
import './Eme.scss';
import eme from "videojs-contrib-eme";

videojs.registerPlugin('eme', eme);
